export default __webpack_public_path__ + "static/media/babiesAndWhales.cc286793.mp3";